export class ApiError extends Error {
  constructor(message, { statusCode, data, isNetworkError }) {
    super(message);
    this.name = 'ApiError';
    this.statusCode = statusCode;
    this.data = data;
    this.isNetworkError = isNetworkError;
    if (Error.captureStackTrace) Error.captureStackTrace(this, ApiError);
  }
}
